let brick;
function show(options) {
  if (brick) {
    return brick.resolve(options);
  } else {
    if (options.type === "confirm") {
      const confirmed = confirm(options.content);
      return new Promise((resolve, reject) => setTimeout(() => {
        (confirmed ? resolve : reject)();
      }, 1));
    } else {
      alert(options.content);
      return new Promise(resolve => setTimeout(() => {
        resolve();
      }, 1));
    }
  }
}
export function loadDialogService(tagName, loader) {
  loader([tagName]).then(() => {
    brick = document.createElement(tagName);
  }, error => {
    // eslint-disable-next-line no-console
    console.error("Load dialog service failed:", error);
  });
}
export const Dialog = Object.freeze({
  show
});
//# sourceMappingURL=Dialog.js.map